import { SelectInput } from '@interstate/components/SelectInput';
import { Typography } from '@interstate/components/Typography';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Box } from '@material-ui/core';
import { BalloonTermTypeInfo } from './BalloonTermTypeInfo.interstate';
import { toRem } from '../../utils/pixelUtils';
import { useBalloonTermTypeField } from './hooks/useBalloonTermTypeField';

const BalloonTermTypeField = () => {
    const { label, selectProps } = useBalloonTermTypeField();
    const theme = useInterstateTheme();

    const elementId = 'balloon-term-type-field';

    return (
        <Box display="flex" flexDirection="column" gridRowGap={toRem(2)} sx={{ marginY: toRem(-1) }}>
            <Box display="flex" alignItems="start" gridColumnGap={toRem(4)} paddingY={toRem(2)}>
                <Typography
                    tag="label"
                    variant="label-sm"
                    color={theme.tokens.ColorOnSurfaceMuted}
                    sx={{ padding: 0, marginBottom: toRem(3) }}
                >
                    {label}
                </Typography>
                <BalloonTermTypeInfo />
            </Box>
            <SelectInput
                id={elementId}
                {...selectProps}
                sx={{
                    [`#select-input-options-${elementId}`]: {
                        height: toRem(28)
                    }
                }}
            />
        </Box>
    );
};

export default BalloonTermTypeField;
